import React from 'react';
import { CheckCircle } from 'lucide-react';

const structureOptions = [
  'Full buyout at completion',
  'Phased transition with handover period',
  'Short-term seller involvement',
  'Funding-aligned structures',
];

const DealStructure = () => {
  return (
    <section 
      id="deal-structure" 
      className="py-16 px-6 bg-section-alt"
      data-testid="deal-structure-section"
    >
      <div className="max-w-5xl mx-auto">
        <h2 className="text-[2rem] md:text-[2.5rem] font-bold text-[#1a1a1a] mb-3 tracking-tight">
          Deal Structure
        </h2>
        <p className="text-[#5a5a5a] mb-6">
          Pragmatic and flexible. We prioritise clarity and fairness.
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-3">
          {structureOptions.map((option, index) => (
            <div key={index} className="section-card p-4 flex items-center gap-3">
              <CheckCircle className="w-4 h-4 text-[#1e3a5f] flex-shrink-0" />
              <span className="text-sm text-[#3d3d3d]">{option}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default DealStructure;
